import { useState, useEffect } from "react";
import Lottie from "lottie-react";
import background_1 from "../animations/background_1.json";
import Style from '../styles/ChangeInitialPass.module.css';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import EnviarEmail from "../services/EnviarEmail";
import { decrypt, encrypt } from "../helpers/Helpers";
import { useNavigate } from 'react-router-dom';
import moment from "moment";


function ChangePasswordByEmail() {

    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [error, setError] = useState('');
    const [attemptsRemaining, setAttemptsRemaining] = useState(null);
    const [isBlocked, setIsBlocked] = useState(false);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const validateEmail = (email) => {
        // Expresión regular para validar el formato del email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubmit = () => {
        setLoading(true);
        if (validateEmail(email)) {
            setEmailError('');
            EnviarEmail({crewCode:sessionStorage.getItem('crewCode'), email:email, timestamp:moment().format('YYYY-MM-DD HH:mm:ss')}).then(res => {
                try {
                    const json = JSON.parse(res);
                    if(json.success === false) {
                        setError(json.message || 'Error: try again later');
                        if (json.attempts !== undefined) {
                            setAttemptsRemaining(json.attempts);
                        }
                        if (json.message && json.message.includes('bloqueado')) {
                            setIsBlocked(true);
                        }
                        setLoading(false);
                        return;
                    } else if(json.success === true) {
                        navigate('/InsertCode', { replace: true })
                        return;
                    }
                } catch(e) {
                    // Si no es JSON, puede ser 200
                    if(res == 200){
                        navigate('/InsertCode', { replace: true })
                        return;
                    }
                    setError('Error: try again later');
                }
                setLoading(false);
            })
        } else {
            setEmailError('El formato del correo electrónico es inválido.');
            setLoading(false);
        }
    };

    return (
        <div style={{ minHeight: '100vh', width: '100vw', display: 'flex', flexDirection: 'column', position: 'relative', justifyContent: 'center', alignItems: 'center' }}>
            {error && (
                <div style={{
                    fontSize: 'large',
                    paddingTop: 'px',
                    paddingBottom: '8px',
                    position: "absolute",
                    zIndex: '9999999999',
                    background: isBlocked ? 'linear-gradient(90deg, #dc2626 0%, #991b1b 100%)' : 'linear-gradient(135deg, #0c1a38 0%, #1565c0 100%)',
                    width: '100%',
                    textAlign: 'center',
                    color: '#fff',
                    borderRadius: 10,
                    boxShadow: isBlocked ? '0 4px 18px #dc262633' : '0 4px 18px #1565c033',
                    top: 0,
                    left: 0,
                    letterSpacing: 0.2,
                    fontWeight: 500
                }}>
                    {error}
                    {attemptsRemaining !== null && !isBlocked && (
                        <div style={{
                            margin: '8px auto 0',
                            padding: '6px',
                            background: 'rgba(255, 255, 255, 0.15)',
                            border: '1.5px solid rgba(255, 255, 255, 0.3)',
                            borderRadius: 6,
                            maxWidth: 440,
                            fontWeight: 600,
                            fontSize: '.85em',
                            letterSpacing: 0.1
                        }}>
                            Intentos restantes: {attemptsRemaining}
                        </div>
                    )}
                    {error === 'El email no coincide con el registrado para este usuario.' && !isBlocked && (
                        <div style={{
                            margin: '8px auto 0',
                            padding: '6px',
                            background: 'linear-gradient(90deg, #fbbf24 0%, #f59e42 100%)',
                            color: '#1e293b',
                            border: '1.5px solid #f59e42',
                            borderRadius: 8,
                            maxWidth: 440,
                            fontWeight: 600,
                            fontSize: '.8em',
                            letterSpacing: 0.1
                        }}>
                            Acuda a su supervisor para proceder con el reinicio de contraseña
                        </div>
                    )}
                </div>
            )}
            <div className={Style.ChangePassContainer}>
                <div className={Style.form_container}>
                        <h3 className={Style.form_title}>INSERT EMAIL</h3>
                        <div className={Style.password_container}>
                            <TextField
                                id="outlined-basic"
                                variant="outlined"
                                className={Style.textfield}
                                type='text'
                                value={email}
                                size="small"
                                placeholder="EMAIL"
                                onChange={(e) => setEmail(e.target.value)}
                                error={Boolean(emailError)}
                                helperText={emailError}
                                disabled={isBlocked}
                                autoComplete="off"
                            />
                        </div>
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={loading || isBlocked}
                            onClick={handleSubmit}
                        >
                            {isBlocked ? 'Cuenta Bloqueada' : 'Submit'}
                        </Button>
                    </div>
                </div>
            <Lottie
                className={Style.lottie_file}
                autoplay={false}
                loop
                animationData={background_1}
            />
        </div>
    );
}

export default ChangePasswordByEmail;
